import React from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "@sscs/ui";
import { OIDCUserMappingFormFields } from "../../types";
import FormPanel from "../FormPanel/FormPanel";

function UserMapping(): React.JSX.Element {
  const {
    formState: { errors },
  } = useFormContext<OIDCUserMappingFormFields>();

  return (
    <FormPanel
      title="User attribute mapping"
      byline="These fields help map the values in your SSO identity provider user records to the Spectra Assure user profile"
    >
      <Form.TextField
        label="Email"
        isRequired
        name="user_email_mapping"
        id="user_email_mapping"
        helperText="The claim containing the users's unique email address"
        errors={errors}
      />
      <Form.TextField
        label="First name"
        name="user_first_name_mapping"
        id="user_first_name_mapping"
        helperText="The claim containing the users's first name"
        errors={errors}
      />
      <Form.TextField
        label="Last name"
        name="user_last_name_mapping"
        id="user_last_name_mapping"
        helperText="The claim containing the users's last name"
        errors={errors}
      />
      <Form.TextField
        label="Groups"
        isRequired
        name="user_groups_mapping"
        id="user_groups_mapping"
        helperText="The claim containing the list of the users's groups"
        errors={errors}
      />
    </FormPanel>
  );
}

export default UserMapping;
